import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  Link,
  List,
  ListItem,
  ListSubheader,
  Toolbar,
  Typography,
} from '@mui/material'
import { Fragment, ReactElement, useState } from 'react'
import EnvironmentChip from './EnvironmentChip'
import routes from '../utils/routes'

function Header(): ReactElement {
  const [open, setOpen] = useState(false)

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const drawerMenus = [
    {
      subHeader: '特集',
      items: [
        {
          title: '一覧',
          link: routes.staff_admin_featured_articles_path(),
        },
      ],
    },
  ]

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
          <Link href={routes.root_path} color="inherit" sx={{ textDecoration: 'none' }}>
            <Typography>特集</Typography>
          </Link>
          <Box ml={2}>
            <EnvironmentChip />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="persistent" anchor="left" open={open}>
        <Box minWidth={'240px'}>
          <Box>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </Box>
          <Divider />
          <List>
            <Link href={routes.root_path} color="inherit">
              <ListItem button>トップ</ListItem>
            </Link>
            <Divider />
            {drawerMenus.map((drawerMenu, listIndex) => (
              <Fragment key={listIndex}>
                <ListSubheader>{drawerMenu.subHeader}</ListSubheader>
                {drawerMenu.items.map((item, itemIndex) => (
                  <Link href={item.link} key={`${listIndex}_${itemIndex}`} color="inherit">
                    <ListItem button>
                      <Box ml={2}>{item.title}</Box>
                    </ListItem>
                  </Link>
                ))}
                <Divider />
              </Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  )
}

export default Header
